import { useEffect, useRef } from 'react'

import { deviceTakeoverCopy } from '../../billing/paywallCopy'

type DeviceTakeoverModalProps = {
  open: boolean
  message: string
  loading?: boolean
  onConfirm: () => void
  onDismiss: () => void
}

/**
 * Промпт «войти здесь» при лимите устройств: вместо тупика предлагаем переключить
 * активную сессию на текущее устройство (на другом произойдёт выход).
 */
export const DeviceTakeoverModal = ({
  open,
  message,
  loading = false,
  onConfirm,
  onDismiss,
}: DeviceTakeoverModalProps) => {
  const dialogRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!open) {
      return
    }
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && !loading) {
        onDismiss()
      }
    }
    document.addEventListener('keydown', handleKeyDown)
    dialogRef.current?.focus()
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [open, loading, onDismiss])

  if (!open) {
    return null
  }

  return (
    <div
      className="market-paywall-overlay"
      role="presentation"
      onClick={() => {
        if (!loading) {
          onDismiss()
        }
      }}
    >
      <div
        ref={dialogRef}
        className="market-paywall-modal"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="device-takeover-title"
        aria-describedby="device-takeover-message"
        tabIndex={-1}
        onClick={(event) => event.stopPropagation()}
      >
        <h2 id="device-takeover-title" className="market-paywall-modal__title">
          {deviceTakeoverCopy.title}
        </h2>
        <p id="device-takeover-message" className="market-paywall-modal__message">
          {message}
        </p>
        <div className="market-paywall-modal__actions">
          <button
            type="button"
            className="echat-btn echat-btn--ghost"
            onClick={onDismiss}
            disabled={loading}
          >
            {deviceTakeoverCopy.dismiss}
          </button>
          <button
            type="button"
            className="echat-btn echat-btn--primary"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? 'Входим…' : deviceTakeoverCopy.primary}
          </button>
        </div>
      </div>
    </div>
  )
}
